import React from 'react';
import ServiceWorkspace from '../../../../components/services/ServiceWorkspace';

type OrganizationServicesPanelProps = {
  orgId: string;
  orgName: string;
};

export default function OrganizationServicesPanel({
  orgId,
  orgName,
}: OrganizationServicesPanelProps) {
  return (
    <ServiceWorkspace
      mode="staff"
      orgId={orgId}
      organizationName={orgName}
      compact
    />
  );
}
